import React from "react";
import { ITestPlanInstrument } from "../../models/testplan/TestplanInstrument";
import { IInstrumentPartition, ITestPlanDirection } from "../../models/testplan/InstrumentPartition";
import { Translation } from "react-i18next";
import * as CONSTANTS from "../../utilities/Constants";
import {  Tooltip, WithTooltip } from "@abb/abb-common-ux-react";

interface IProps {
    instrument: ITestPlanInstrument;
    partition: IInstrumentPartition;
    editToggle?: (instrument: ITestPlanInstrument, partition: IInstrumentPartition) => void;
}


export default class MeasuredPartition extends React.Component<IProps> {

    public render() {
        return (
            <Translation>
                {
                    t =>
                        // tslint:disable-next-line: jsx-no-lambda 
                        <div className="stepwizard-step" onClick={() => this.props.editToggle(this.props.instrument,
                            this.props.partition)}>
                            <a href="#step-1" className="position-bar" />
                            <div className="position-header">
                                <WithTooltip>
                                    <p className="position-font-header text-ellipsis width-5rem">{this.props.partition.name}</p>
                                    <Tooltip style={{width:"100%"}}>
                                        <p>{this.props.partition.name}</p>
                                    </Tooltip>
                                </WithTooltip>
                            </div>
                            <div className="position-content">
                                <div>
                                    <p className="position-font">{t(CONSTANTS.POSITION_WIDTH)}: </p>
                                    <p className="position-font" style={{ fontSize: 16 }}>{this.props.partition.positionWidth} mm</p>
                                </div>
                                <hr className="hr-line position-content-line" />
                                {
                                    this.props.partition.directions.map((data: ITestPlanDirection, index) =>
                                        <React.Fragment key={index}>
                                            <div className="mb-2 text-center">
                                                <p className="position-font">{data.name} {t(CONSTANTS.LABEL_COUNT)}:  {data.count}</p>
                                            </div>
                                            <hr className="hr-line position-content-line" />
                                        </React.Fragment>
                                    )
                                }
                            </div>
                        </div>

                }
            </Translation>
        );
    }
}